import { OPM } from 'common/constants/allocations';
import { ValuationByAllocation } from 'common/types/valuation/valuation';
import { getNumberValue } from 'utilities';
import { getBacksolveScenarioMethods } from '../getBacksolveScenarioMethods';
import { getFutureExitScenarioMethod } from '../getFutureExitScenarioMethod';

/**
 * Whether anything on the valuation prices with the Option Pricing Model: an OPM allocation
 * scenario, a Backsolve or Future Exit approach using OPM, or an OPM Calculator tab that already
 * exists. The calculator is only offered in the Add menu once one of these holds -- on a clean
 * valuation there is nothing for it to reproduce.
 */
const valuationUsesOPM = (valuation?: Partial<ValuationByAllocation> | null): boolean => {
  if (!valuation) {
    return false;
  }

  if ((valuation.opm_calculators ?? []).length > 0) {
    return true;
  }

  const hasOPMScenario = (valuation.allocation?.allocation_scenarios ?? []).some(
    scenario => getNumberValue(scenario?.scenario_method) === OPM
  );
  if (hasOPMScenario) {
    return true;
  }

  return (valuation.valuations_approaches ?? []).some(
    approach =>
      getBacksolveScenarioMethods(approach?.valuations_approach_backsolve ?? undefined).isBacksolveWithOPM
      || getFutureExitScenarioMethod(approach?.valuations_approach_future_exit ?? undefined).isFutureExitWithOPM
  );
};

export default valuationUsesOPM;
